// Sons synthétisés (Web Audio) : aucun fichier à charger, fonctionne hors-ligne
const SOUND_KEY = 'muscuapp_sound';

// [fréquence Hz, début s, durée s]
const SOUNDS = {
  timerEnd: { type: 'square', gain: 0.2, notes: [[880, 0, 0.2], [880, 0.25, 0.2], [1175, 0.5, 0.3]] },
  sessionStart: { type: 'triangle', gain: 0.3, notes: [[523, 0, 0.15], [784, 0.15, 0.3]] },
  trophy: { type: 'triangle', gain: 0.3, notes: [[523, 0, 0.15], [659, 0.15, 0.15], [784, 0.3, 0.15], [1047, 0.45, 0.5]] },
  record: { type: 'sine', gain: 0.3, notes: [[659, 0, 0.1], [880, 0.1, 0.1], [1109, 0.2, 0.1], [1319, 0.3, 0.4]] },
  sessionEnd: { type: 'triangle', gain: 0.25, notes: [[392, 0, 0.2], [523, 0.2, 0.2], [659, 0.4, 0.2], [784, 0.6, 0.2], [1047, 0.8, 0.2], [784, 0.8, 0.8], [1047, 0.8, 0.8], [1319, 0.8, 0.8]] },
};

let ctx = null;

export function isSoundEnabled() {
  try {
    return localStorage.getItem(SOUND_KEY) !== '0';
  } catch (_) {
    return true;
  }
}

export function setSoundEnabled(enabled) {
  try {
    localStorage.setItem(SOUND_KEY, enabled ? '1' : '0');
  } catch (_) {}
}

function getContext() {
  const Ctor = typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
  if (!Ctor) return null;
  if (!ctx) ctx = new Ctor();
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

export function playSound(name) {
  const sound = SOUNDS[name];
  if (!sound || !isSoundEnabled()) return;
  try {
    const audio = getContext();
    if (!audio) return;
    const now = audio.currentTime;
    sound.notes.forEach(([freq, start, duration]) => {
      const osc = audio.createOscillator();
      const gain = audio.createGain();
      osc.type = sound.type;
      osc.frequency.value = freq;
      osc.connect(gain);
      gain.connect(audio.destination);
      gain.gain.setValueAtTime(sound.gain, now + start);
      gain.gain.exponentialRampToValueAtTime(0.001, now + start + duration);
      osc.start(now + start);
      osc.stop(now + start + duration);
    });
  } catch (_) {}
}

// Débloque l'audio mobile : à appeler depuis un geste utilisateur
export function unlockAudio() {
  try {
    getContext();
  } catch (_) {}
}
